import React, { useState } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { registerUser } from '../../../api/api_users';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const RegisterComponent = () => {
    const { translations } = useLanguage();
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [timezone, setTimezone] = useState(10);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== repeatPassword) {
            setError(translations.passwords_not_match);
            return;
        }

        const userDetails = { 
            user_name: userName, 
            email, 
            password, 
            timezone: timezone
        };

        try {
            await registerUser(userDetails);
            navigate('/login');
        } catch (err) {
            setError(translations.error_registering);
            console.error('Error registering:', err);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleRepeatPasswordVisibility = () => {
        setShowRepeatPassword(!showRepeatPassword);
    };

    const handleBack = () => {
        navigate('/login');
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="header">
                    <button onClick={handleBack} className="back-button">&#8592;</button>
                    <h1>{translations.register}</h1>
                </div>
                <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                        <input 
                            type="text" 
                            value={userName} 
                            onChange={(e) => setUserName(e.target.value)} 
                            placeholder={translations.username}
                            className="login-input"
                        />
                    </div>
                    <div className="form-group">
                        <input 
                            type="email" 
                            value={email} 
                            onChange={(e) => setEmail(e.target.value)} 
                            placeholder={translations.email}
                            className="login-input"
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder={translations.pass}
                            className="login-input"
                        />
                        <button 
                            type="button" 
                            className="password-toggle-button" 
                            onClick={togglePasswordVisibility}
                        >
                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                        </button>
                    </div>
                    <div className="form-group">
                        <input 
                            type={showRepeatPassword ? 'text' : 'password'}
                            value={repeatPassword}
                            onChange={(e) => setRepeatPassword(e.target.value)} 
                            placeholder={translations.repeat_pass}
                            className="login-input"
                        />
                        <button 
                            type="button" 
                            className="password-toggle-button" 
                            onClick={toggleRepeatPasswordVisibility}
                        >
                            <FontAwesomeIcon icon={showRepeatPassword ? faEyeSlash : faEye} />
                        </button>
                    </div>
                    <div className="form-group">
                        <select 
                            id="timeZone" 
                            className="login-input" 
                            value={timezone} 
                            onChange={(e) => setTimezone(Number(e.target.value))}>
                            <option value="0">Los Angeles (UTC -8)</option>
                            <option value="1">Denver (UTC -7)</option>
                            <option value="2">Chicago (UTC -6)</option>
                            <option value="3">New York (UTC -5)</option>
                            <option value="4">Toronto (UTC -5)</option>
                            <option value="5">Sao Paulo (UTC -3)</option>
                            <option value="6">London (UTC +0)</option>
                            <option value="7">Madrid (UTC +1)</option>
                            <option value="8">Paris (UTC +1)</option>
                            <option value="9">Rome (UTC +1)</option>
                            <option value="10">Berlin (UTC +1)</option>
                            <option value="11">Johannesburg (UTC +2)</option>
                            <option value="12">Istanbul (UTC +3)</option>
                            <option value="13">Moscow (UTC +3)</option>
                            <option value="14">Dubai (UTC +4)</option>
                            <option value="15">Shanghai (UTC +8)</option>
                            <option value="16">Hong Kong (UTC +8)</option>
                            <option value="17">Singapore (UTC +8)</option>
                            <option value="18">Tokyo (UTC +9)</option>
                            <option value="19">Sydney (UTC +10)</option>
                        </select>
                    </div>
                    {error && <div className="login-error">{error}</div>}
                    <button type="submit" className="login-button secondary-button">{translations.sign_up}</button>
                </form>
            </div>
        </div>
    );
};

export default RegisterComponent;
